export enum commonActions {
    AUTHORIZE = 'AUTHORIZE',
    SYSTEM_CHANGED = 'SYSTEM_CHANGED',
    ENVIRONMENT_CHANGED = 'ENVIRONMENT_CHANGED',
    SET_LOCAL_FEATURE_FLAGS = 'SET_LOCAL_FEATURE_FLAGS',
    SET_FORCE_ANALYTICS_SOURCE = 'SET_FORCE_ANALYTICS_SOURCE'
}
